import { RisksId } from "../../../../helpers/risk";
import TextInput from "../../../sharedComponents/textInput/textInput";
import React from "react";
import { CalculateStore } from "../../../../stores/calculateStore";
import { inject, observer } from "mobx-react";


interface InsuranceSumDropDownProps {
    calculateStore?: CalculateStore;
    riskId: RisksId;
    value: string;
}

export function InsuranceSumFixed(props: InsuranceSumDropDownProps) {
    const calculateStore = props.calculateStore!;

    if (!(props.riskId in calculateStore.additionalInsurances)) {
        return null;
    }

    // @ts-ignore
    const risk = calculateStore.additionalInsurances[props.riskId];

    return (
        <div className="insurance-fixed-sum-and-rate-container">

            <TextInput
                disabled={true}
                className="fixed-insurance-sum"
                topLabel={"Suma ubezpieczenia (zł)"}
                value={props.value} />

            <TextInput
                disabled={true}
                className="rate"
                value={risk.rate || "?"}
                topLabel="Składka (zł)"
            />
        </div>
    );
}

export default inject("calculateStore")(observer(InsuranceSumFixed));
